export const TWITTER_UUID = '__vf_twttr__';
export const INSTAGRAM_UUID = '__vf_instgrm__';
export const ORIGIN_TWITTER = 'twitter';
export const ORIGIN_INSTAGRAM = 'instagram';
export const ORIGIN_USER = 'user';
export const ORIGIN_NONE = 'none';
